import { GlobalState } from 'src/redux/store';

export const tenantsSelector = (state: GlobalState) => state.tenants;

export const tenantsSelectorData = (state: GlobalState) => tenantsSelector(state).data;

export const tenantsStatusSelector = (state: GlobalState) => tenantsSelector(state).status;
